import { useEffect } from "react";
import { connect } from "react-redux";
import DocumentMeta from "react-document-meta";
import { withRouter, Link } from "react-router-dom";

import FindMentorImg from "../../assets/images/find_mentor_img.jpg";
import WhoMentor from "./components/WhoMentor/WhoMentor";
import RoleMentor from "./components/RoleMentor/RoleMentor";
import MentorBenefits from "./components/MentorBenefits/MentorBenefits";
import FindAMentor from "./components/FindAMentor/FindAMentor";

import { getBecomeMentorData, getMentorListData } from "./dependencies/action";

import { initGA, logPageView } from "../../analytics";

const BecomeMentor = (props) => {
  useEffect(() => {
    // to call the initialise google analytics funtion
    try {
      initGA();
      window.GA_INITIALIZED = true;
      // to save the number og visitors on this side
      logPageView();
    } catch (error) {}
  }, [window]);

  const {
    getBecomeMentorData,
    currentInterventionList,
    getMentorListData,
    mentorListData,
  } = props;

  useEffect(() => {
    getBecomeMentorData(localStorage.getItem("SelectedLang"));
    getMentorListData({
      sortKey: "name",
      sortOrder: "ASC",
      searchField: "",
      searchKey: "",
    });
  }, [getBecomeMentorData, getMentorListData]);

  const Banner = currentInterventionList?.Banner;
  const Benefitsofbecomeamentor =
    currentInterventionList?.Benefitsofbecomeamentor;
  const FindaMentorforYourUniqueNeeds =
    currentInterventionList?.FindaMentorforYourUniqueNeeds;
  const Howtocontribute = currentInterventionList?.Howtocontribute;
  const Mentor = currentInterventionList?.mentor;
  const meta={
    title: 'MAARG',
    description: '',
    canonical: 'https://maarg.startupindia.gov.in/',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'Mentorship,startupindia,startup, mentor, Mentor , Startup'
        }
    }
};
  return (
    <DocumentMeta {...meta}>
      <div style={{ marginTop: "50px" }}>
        <div>
          {currentInterventionList ? (
            <>
              <WhoMentor data={Banner} />
              <RoleMentor data={Benefitsofbecomeamentor} />
              <MentorBenefits data={Howtocontribute} />
              <FindAMentor data={FindaMentorforYourUniqueNeeds} />
               
              {/*same components from get mentors page*/}
              {/* <ConnectMentor data={Mentor} /> */}
            </>
          ) : null}
          {/* <img src={FindMentorImg} /> */}
        </div>
      </div>
    </DocumentMeta>
  );
};
const mapStateToProps = (state) => {
  return {
    currentInterventionList:
      state.BecomeMentorReducer.currentInerventionList.list,
    mentorListData: state.BecomeMentorReducer.mentorListData,
  };
};
export default connect(mapStateToProps, {
  getBecomeMentorData,
  getMentorListData,
})(withRouter(BecomeMentor));
